window.Freshwater = {
    DEBUG_MODE: false,
    console: function(type, ...messages) {
        if (!this.DEBUG_MODE) return;
        const style = "background-color: #e0e8ff; color: #2a52c9; font-weight: bold; margin-bottom: 2px; padding: 2px;";
        if (["log", "warn", "error"].includes(type)) {
            console[type]("🔹 %cFreshwater", style, ...messages);
        }
    }
};

/* check for debug_mode param in URL */
(function() {
    const params = new URLSearchParams(window.location.search);
    if (params.get("debug_mode") === "true") {
        window.Freshwater.DEBUG_MODE = true;
    }
})();


$0(document).ready(function () {

    //open external links in new tab
    var links = document.links;
    for (let i = 0, linksLength = links.length; i < linksLength; i++) {
        if (links[i].hostname !== window.location.hostname) {
            links[i].target = '_blank';
            links[i].rel = 'noreferrer noopener';
        }
    }

	// Add smooth scrolling
	var hashTagActive = "";
	$0(".smooth-scroll").on("click touchstart", function (event) {
		if (hashTagActive != this.hash) { //this will prevent if the user click several times the same link to freeze the scroll.
            event.preventDefault();
            $0('html, body').animate({
                scrollTop: $0($0.attr(this, 'href')).offset().top
            }, 1500);
    
            //scroll again to adjust for height difference from any lazy loading
            setTimeout(() => {
                $0('html, body').animate({
                    scrollTop: $0($0.attr(this, 'href')).offset().top
                }, 200);
            }, "1000");

			hashTagActive = this.hash;

			//close menu
			$0("#Details-menu-drawer-container").removeClass("menu-opening").removeAttr("open");
		}

	});
  
    $0(".header__menu-item.header__menu-item.list-menu__item").click(function(){
      console.log("finally");
      $0(".header__inline-menu .toggle").prop('checked', false);    
    });
  
	//smooth scroll
	$0("#smooth-scroll, #smooth-scroll2").on('click', function(event) {
		if (this.hash !== "") {
			event.preventDefault();
			var hash = this.hash;
			$0('html, body').animate({
				scrollTop: $0(hash).offset().top
			}, 1500, function(){
			});
		}
	});	


    //add background color to header on scroll
    $0(window).scroll(function () {
        if ($0(document).scrollTop() > 100) {
            $0("sticky-header").addClass("header-background-color");

        } else {
            $0("sticky-header").removeClass("header-background-color");
        }
    });

	//show bottom buy bar
	$0(window).scroll(function () {
		if ($0(document).scrollTop() > 600) {
			$0('#buy-bar').addClass('show');
            $0('body').addClass('buy-bar-visible');

		} else {
			$0('#buy-bar').removeClass('show');
            $0('body').removeClass('buy-bar-visible');
		}
	});



	var checkExist = setInterval(function() {
		if ($0("#looxCarouselFrame").length) {			
			// $0("#looxCarouselFrame").contents().find(".branding").addClass("hide-loox-banner");
			$0("#looxCarouselFrame").contents().find( ".branding a" ).css("color", "#ffffff");
			clearInterval(checkExist);
		}
	}, 10);

	/*mobile dropdown menu**/
	$0(".open-fresh-menu").click(function() {
		$0(this).hide();
		$0("span.open-fresh-menu.menu-icon-close").show();
		$0(".fresh-mobile-menu-cover").show();
		$0(".fresh-mobile-menu, .fresh-mobile-menu-cover").slideDown();						
		$0("body.index").addClass("is-active");
	})
	$0(".menu-icon-close, .fresh-mobile-menu-cover").click(function() {
		$0(this).hide();
		$0("span.open-fresh-menu.menu-icon-open").show();						
		$0(".fresh-mobile-menu-cover").hide();
		$0(".fresh-mobile-menu").hide();		
		$0("body.index").removeClass("is-active");
	}) 

	$0(window).scroll(function () {
		if ($0(document).scrollTop() > 400) {
			$0('.product-page-scrollbar').addClass('show-product-page-scrollbar');		  		  		 
		} else {
			$0('.product-page-scrollbar').removeClass('show-product-page-scrollbar');	
		}
	});	

	
    //scroll ingredients wrapper
    $0('.ingredient-next-1').on('click', function() {
        $0('.ingredient-prev.ingredient-prev-1').show();
        $0('.custom-ingredient-wrapper-1').animate({
            scrollLeft: '+=500'
        }, 300, 'swing');
    });

    $0('.ingredient-prev-1').on('click', function() {  
        $0('.custom-ingredient-wrapper-1').animate({
            scrollLeft: '-=500'
        }, 300, 'swing');
    });	

    $0('.ingredient-next-2').on('click', function() {	
        $0('.ingredient-prev.ingredient-prev-2').show();  
        $0('.custom-ingredient-wrapper-2').animate({
            scrollLeft: '+=500'
        }, 300, 'swing');
    });

    $0('.ingredient-prev-2').on('click', function() {		
        $0('.custom-ingredient-wrapper-2').animate({
            scrollLeft: '-=500'
        }, 300, 'swing');
    });		


    //recharge quick actions page
    $0("<img class='recharge-quickactions-img' src='https://cdn.shopify.com/s/files/1/0405/9870/0189/files/avantera-elevate1.jpg?v=1620432649' />").insertBefore("#qa-section-verification-code-prompt");
    $0("#quickactions").parent().addClass("recharge-padding-0");


    //scrape url parameters
    if (window.location.href.indexOf("?shop") > -1) {
        $0(".hide-from-packs").hide();
    }	

	//product page slick carousel
	$0('.fresh-product-carousel').slick({
		fade: true,
		swipe:false,
		arrows:true,
		autoplay:false,
		dots: false,
		infinite: true,
		speed: 700,
		slidesToShow: 1,
		adaptiveHeight: false
	});
	$0('.fresh-product-carousel-test-a29').slick({
		fade: true,
		swipe:false,
		arrows:true,
		autoplay:false,
		dots: false,
		infinite: true,
		speed: 700,
		slidesToShow: 1,
		adaptiveHeight: false
	});  
	$0('.fresh-product-carousel-test-a44').slick({
		fade: true,
		swipe:false,
		arrows:true,
		autoplay:false,
		dots: false,
		infinite: true,
		speed: 700,
		slidesToShow: 1,
		adaptiveHeight: false
	});    
	$0('.fresh-product-carousel-test-a60').slick({
		fade: true,
		swipe:false,
		arrows:true,
		autoplay:false,
		dots: false,
		infinite: true,
		speed: 700,
		slidesToShow: 1,
		adaptiveHeight: false
	}); 
	$0('.fresh-product-carousel-test-a61-var1').slick({
		fade: true,
		swipe:false,
		arrows:true,
		autoplay:false,
		dots: false,
		infinite: true,
		speed: 700,
		slidesToShow: 1,
		adaptiveHeight: false
	}); 
	$0('.fresh-product-carousel-test-a61-var2').slick({
		fade: true,
		swipe:false,
		arrows:true,
		autoplay:false,
		dots: false,
		infinite: true,
		speed: 700,
		slidesToShow: 1,
		adaptiveHeight: false
	});
	$0('.fresh-product-carousel-test-a76-var2').slick({
		fade: true,
		swipe:false,
		arrows:true,
		autoplay:false,
		dots: false,
		infinite: true,
		speed: 700,
		slidesToShow: 1,
		adaptiveHeight: false
	});     

    //footer prop65 warning
    $0(".show-prop65").click(function(){
      $0(".prop65-wrapper").show();
    });
    $0(".close-prop65, .close-prop65-alt").click(function(){
      $0(".prop65-wrapper").hide();
    });  

	////////////
	///UPSELL///
	///////////

	//close popup
	$0(".close-popup").click(function(){
        $0("#upsell-popup").fadeOut();
		$0("body").removeClass("upsell-open");
    });


	$0("#upsell-elevate-sub1").click(function(){
        $0("#upsell-popup").removeClass("once");
		$0("#upsell-popup").addClass("sub");
		$0("#upsell-popup").fadeIn(600);
		$0(".product-page-scrollbar.products").hide();
		$0("body").addClass("upsell-open");
		
    });
	$0("#upsell-elevate-once1").click(function(){
        $0("#upsell-popup").removeClass("sub");
		$0("#upsell-popup").addClass("once");
		$0("#upsell-popup").fadeIn(600);
		$0(".product-page-scrollbar.products").hide();
		$0("body").addClass("upsell-open");
    });	




});